var exports = {
  "MO": "VoiceParticipantItem.module__participantRow___V0tFTD",
  "Kq": "VoiceParticipantItem.module__participantRowSpeaking___V0tFTD",
  "JN": "VoiceParticipantItem.module__participantRowDragging___V0tFTD",
  "z": "VoiceParticipantItem.module__participantRowCurrentConnection___V0tFTD",
  "B$": "VoiceParticipantItem.module__participantRowPopoutOpen___V0tFTD",
  "K0": "VoiceParticipantItem.module__participantRowContextMenuActive___V0tFTD",
  "Kt": "VoiceParticipantItem.module__deviceIcon___V0tFTD",
  "iY": "VoiceParticipantItem.module__deviceIconSpeaking___V0tFTD",
  "ns": "VoiceParticipantItem.module__deviceIconCurrent___V0tFTD",
  "zc": "VoiceParticipantItem.module__iconContainer___V0tFTD",
  "F8": "VoiceParticipantItem.module__participantName___V0tFTD",
  "xr": "VoiceParticipantItem.module__participantNameSpeaking___V0tFTD",
  "S$": "VoiceParticipantItem.module__participantNameCurrent___V0tFTD",
  "_q": "VoiceParticipantItem.module__iconsContainer___V0tFTD",
  "nt": "VoiceParticipantItem.module__flexShrinkZero___V0tFTD",
};

module.exports = exports;
